import { FC } from "react";
import { PaxCheckPickFromListQuestion, PaxCheckOption } from "api";

import FromListPicker from "features/shared/components/picker/FromListPicker";

import QuestionBox from "../../styles/QuestionBox.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import { capitalizeTitle } from "utils";

interface QuestionProps {
  question: PaxCheckPickFromListQuestion;
  options: PaxCheckOption[];
  answer: string | boolean | undefined;
  error: string | null;
  handleChange: (id: string) => (value: string) => void;
}

const PickFromListQuestion: FC<QuestionProps> = ({
  question,
  options,
  answer,
  error,
  handleChange,
}) => {
  const pickerOptions = options.map((option) => {
    return {
      id: option.id,
      value: capitalizeTitle(option.title),
    };
  });

  return (
    <QuestionBox>
      <MicroHeader>{question.questionTitle.name}</MicroHeader>
      <FromListPicker
        id={question.id}
        label={question.questionTitle.subtitle || undefined}
        options={pickerOptions}
        value={answer !== undefined ? (answer as string) : undefined}
        onChange={handleChange(question.id)}
        error={error}
      />
    </QuestionBox>
  );
};

export default PickFromListQuestion;
